export const LoaderKey = {
  GLOBAL: 'global',
  APP_BOOTSTRAP: 'app-bootstrap',
  SIGN_IN: 'sign-in',
  SIGN_OUT: 'sign-out',
  ACCOUNT_LISTING: 'account-listing',
  MY_ACCOUNTS_LISTING: 'my-accounts-listing',
  GUEST_LISTING: 'guest-listing',
  REVIEW_LISTING: 'review-listing',
  SERVICE_TICKET_LISTING: 'service-ticket-listing',
  SERVICE_TICKET_BOARD: 'service-ticket-board',
  SERVICE_TICKET_COUNTS: 'service-ticket-counts',
  SERVICE_TICKET_DETAIL: 'service-ticket-detail',
  SERVICE_TICKET_SAVE: 'service-ticket-save',
  DEPARTMENT_LISTING: 'department-listing',
  DEPARTMENT_SAVE: 'department-save',
  TAG_LISTING: 'tag-listing',
  TAG_SAVE: 'tag-save',
  VIEW_LISTING: 'view-listing',
  VIEW_SAVE: 'view-save',
  SERVICE_TICKET_STATUS_LISTING: 'service-ticket-status-listing',
  SERVICE_TICKET_STATUS_SAVE: 'service-ticket-status-save',
  REPORT_LISTING: 'report-listing',
  ORGANIZATION_LISTING: 'organization-listing',
  ORGANIZATION_MEMBER_LISTING: 'organization-member-listing',
  ROLE_LISTING: 'role-listing',
  ROLE_SAVE: 'role-save',
  ROLE_MEMBER_SAVE: 'role-member-save',
  PLAN_CHANGE: 'plan-change',
  QUESTIONNAIRE_LISTING: 'questionnaire-listing',
  QUESTIONNAIRE_SAVE: 'questionnaire-save',
} as const;

export type LoaderKey = (typeof LoaderKey)[keyof typeof LoaderKey];
